export default {
    "cy": {
        "application": {
            "welcome": {
                "content": "Diolch am ymweld â’n llwyfan ar gyfer y pecyn cymorth. Rydych wedi cyrraedd y dudalen hon drwy gamgymeriad. I gyrchu’r pecyn cymorth ar gyfer eich rhaglen, defnyddiwch yr URL llawn. Os nad ydych yn sicr beth yw URL eich rhaglen, cysylltwch â <a href=\"mailto:toolkit@sos-uk.org\">toolkit@sos-uk.org</a>",
                "logo": "Logo"
            },
            "navigation": {
                "manage_account": "Rheoli’r Cyfrif",
                "profile": "Proffil",
                "api_tokens": "Tocynnau API",
                "log_out": "Allgofnodi",
                "manage_team": "Rheoli {team_name}",
                "team_settings": "Gosodiadau’r {team_name}",
                "switch_toolkits": "Newid Pecynnau Cymorth",
                "clear_selection": "Clear Selection"
            },
            "general": {
                "cancel": "Canslo",
                "password": "Cyfrin-air",
                "error": "Wps! Fe aeth rhywbeth o chwith.",
                "find_on_social_media": "Dod o hyd i {name} ar gyfryngau cymdeithasol:"
            },
            "email_validation": {
                "title": "I barhau, dilyswch eich cyfeiriad e-bost.",
                "info": "Dylech fod wedi derbyn e-bost yn y cyfeiriad a ddefnyddioch wrth gofrestru",
                "submit": "Cyflwyno",
                "resend": "Os na dderbynioch chi e-bost, gallwch geisio ailanfon yr e-bost dilysu:",
                "resend_button": "Anfon yr e-bost dilysu eto"
            },
            "email_verification": {
                "info": "Cyn parhau, a fyddech cystal â chadarnhau eich cyfeiriad e-bost drwy glicio ar y ddolen rydym newydd ei hafnon atoch drwy e-bost? Os na dderbynioch chi’r e-bost, byddwn yn ddigon bodlon anfon un arall i chi.",
                "link_sent": "Mae dolen gadarnhau newydd wedi’i hanfon i’r cyfeiriad e-bost rydych wedi’i ddarparu yn eich gosodiadau proffil.",
                "resend_button": "Ailanfon E-bost Cadarnhau"
            },
            "auth": {
                "confirm_password": "Mae hon yn ardal ddiogel o’r rhaglen. A fyddech cystal â chadarnhau eich cyfrin-air cyn parhau.",
                "confirm": "Cadarnhau",
                "forgot_password": "Wedi anghofio eich cyfrin-air? Dim problem. Rhowch wybod i ni beth yw eich cyfeiriad e-bost, a byddwn yn e-bostio dolen ar gyfer ailosod cyfrin-air, fydd yn caniatáu i chi ddewis un newydd.",
                "email": "E-bost",
                "email_password": "E-bost Dolen Ailosod Cyfrin-air",
                "reset_password": "Ailosod eich cyfrin-air",
                "no_content": "Mae’n ddrwg gennym, does dim byd yma ar y funud. Ewch yn ôl i’r <Link href=\"/\" style=\"color{black}\">dudalen hafan</Link> a rhowch gynnig arall arni.",
                "confirm_password_label": "Cadarnhau cyfrin-air",
                "reset_password_button": "Ailosod cyfrin-air",
                "log_in": "Mewngofnodi",
                "2fa": {
                    "recovery": "Gallwch gadarnhau mynediad i’ch cyfrif drwy nodi’r côd dilysu a ddarparwyd gan eich rhaglen ddilysu.",
                    "confirm": "Gallwch gadarnhau mynediad i’ch cyfrif drwy nodi un o’ch codau adfer mewn argyfwng,",
                    "code": "Côd",
                    "recovery_code": "Côd adfer",
                    "recovery_title": "Defnyddio côd adfer",
                    "authentication_title": "Defnyddio côd dilysu"
                }
            }
        },
        "auditor": {
            "login": {
                "code": "Auditor Code",
                "name": "Auditor Name"
            },
            "team": {
                "title": "Welcome",
                "toolkits_audit": "You are auditing toolkits for",
                "assigned_team": "Your assigned team is",
                "select_team": "Please select the team you will be auditing below.",
                "view_toolkit_button": "View team toolkit"
            },
            "submit": "Submit Audit",
            "evidence": "Download All Evidence (.zip)",
            "action": {
                "comments": "Auditor Comments",
                "actions": "Auditor Actions",
                "accept_status": "Accept Status",
                "accepted": "Accepted",
                "further_evidence_required": "Further Evidence Required",
                "suggested_status_change": "Suggested Status Change: ",
                "suggested_points_change": "Suggested Points Change: ",
                "change_points_value": "Change Action Points Value",
                "change_points_value_button": "Go",
                "download_evidence": "Download Evidence (.zip)"
            },
            "toolkit": {
                "auditor_team_questions_heading": "Please ask the team the following questions during the audit",
                "auditor_show_team_questions": "Show Team Questions",
                "auditor_hide_team_questions": "Hide Team Questions"
            },
            "submit_audit": {
                "heading": "Submit Audit",
                "prompt": "Are you sure you want to submit this audit?",
                "warning": "You will no longer be able to edit any audit information after submission.",
                "reminder": "Please remember to answer any questions in the Team Questions section.",
                "cancel": "Cancel",
                "submit": "Submit Audit"
            },
            "auditor_questions": {
                "auditor_questions_heading": "Thanks {auditor}! Before you go...",
                "auditor_questions_introduction": "It would be great if you could answer the below questions about your auditing experience.",
                "auditor_questions_save_reminder": "Please remember to save your answers.",
                "auditor_questions_submit_feedback": "Submit feedback",
                "auditor_questions_error_message": "Something went wrong. Have you checked all required fields have been filled in?",
                "complete_audit": "Complete Audit"
            },
            "audit_complete": {
                "audit_complete_heading": "Audit Complete!",
                "audit_complete_thankyou": "Thank you for taking the time to audit {team}.",
                "audit_complete_notice": "Please ensure that all downloaded files are removed from your machine now.",
                "audit_another_team": "Audit another team",
                "sign_out": "Sign out",
                "enter_another_code": "Enter another code"
            }
        },
        "dashboard": {
            "login": {
                "email": "E-bost",
                "password": "Cyfrin-air",
                "logged_in": "Cadwch fi wedi mewngofnodi",
                "forgot": "Wedi anghofio’ch cyfrin-air?",
                "log_in": "Mewngofnodi",
                "not_a_member": "Ddim yn aelod eto?",
                "register": "Cofrestru",
                "home": "Hafan",
                "no_organisation": "Sorry, you need to specify an organisation to log in to this programme."
            },
            "register": {
                "first_name": "Enw Cyntaf",
                "last_name": "Enw Olaf",
                "email": "E-bost",
                "password": "Cyfrin-air",
                "confirm_password": "Cadarnhau cyfrin-air",
                "password_rules": "Rhaid i’ch cyfrin-air gynnwys o leiaf 10 nod, a chynnwys o leiaf un nod arbennig ac un rhif.",
                "agree": "Rwyf yn cytuno i’r ",
                "privacy_policy": "Polisi Preifatrwydd",
                "registered": "Wedi cofrestru eisoes?",
                "register": "Cofrestru",
                "no_organisation": "Sorry, you need to specify an organisation to register on this programme."
            },
            "title": "Dangosfwrdd",
            "greeting": "Helo, {name}",
            "intro_text": "Gallwch gyrchu eich pecyn cymorth o’r ddewislen ar yr ochr chwith.",
            "sidebar": {
                "dashboard": "Dangosfwrdd",
                "toolkit": "Pecyn cymorth"
            },
            "widgets": {
                "shared": {
                    "status": {
                        "done": "Wedi gwneud",
                        "in_progress": "Ar y gweill",
                        "not_done": "Heb ei wneud",
                        "not_applicable": "Ddim yn berthnasol",
                        "none": "Dim statws"
                    }
                },
                "starred": {
                    "title": "Camau â seren",
                    "empty": "Does gennych chi ddim camau gweithredu â seren ar hyn o bryd."
                },
                "assigned": {
                    "title": "Camau a Bennwyd",
                    "empty": "Does gennych chi ddim camau gweithredu wedi’u pennu ar hyn o bryd."
                },
                "leaderboard": {
                    "title": "Sgorfwrdd",
                    "intro_text": "Y deg tîm uchaf",
                    "points": "yn ôl nifer y pwyntiau a enillwyd",
                    "actions": "yn ôl nifer y camau gweithredu a gyflawnwyd",
                    "position": "Dangoswch safe fy nhîm yn y gynghrair",
                    "empty": "Does gennych chi ddim cynnwys i’w arddangos ar hyn o bryd."
                },
                "awards": {
                    "title": "Cynnydd tuag at Wobrau",
                    "empty": "Does dim gwobrau i’w dangos ar hyn o bryd.",
                    "intro_text": "Gweld cynnydd eich {team_name} tuag at gwblhau gwobrau’r pecyn cymorth hwn.",
                    "points_score_status": "Your {team_name} has completed <strong>{totalCompletedActions}</strong> actions so far, totalling <strong>{totalPoints}</strong> points.",
                    "actions_score_status": "Your {team_name} has completed <strong>{totalCompletedActions}</strong> actions so far.",
                    "obtain": "Obtain",
                    "complete": "Complete",
                    "or_more": "or more",
                    "points": "points",
                    "between": "between",
                    "and": "and",
                    "award": "award",
                    "all": "all",
                    "from": "from",
                    "of": "of",
                    "tagged_actions": "actions tagged with this award",
                    "including_na": "(Including N/A)"
                },
                "new_toolkit": {
                    "new": "New",
                    "content": "There is a new toolkit available to join."
                },
                "previous_toolkits": {
                    "title": "Previous Toolkits"
                },
                "carbon_savings": {
                    "title": "Carbon Savings",
                    "savings_prepend": "Your {team_name} has saved<br />an estimated ",
                    "savings_append": " kg CO<sub>2</sub> so far.*",
                    "savings_text_1": "The carbon saving estimates provided by this online calculator are based on a set of assumptions and general estimates to display an approximate idea of potential carbon savings from specific actions. While the results may not reflect precise savings in every scenario, they serve as a valuable tool to illustrate how certain choices can contribute to reducing carbon footprints. The calculations aim to help teams visualise the impact of adopting more sustainable practices, offering a clearer picture of the positive environmental effects that these efforts could potentially achieve.",
                    "savings_text_2": "No prey, no pay crow's nest nipper jury mast holystone Barbary Coast loot Arr broadside cutlass. Plate Fleet Gold Road grog fore chase Letter of Marque lee parrel black jack line. Brig Barbary Coast gunwalls Pieces of Eight quarterdeck square-rigged belay Buccaneer bilge water doubloon.",
                    "carbon_policy": "Read more about carbon savings in our <a href=\"{link}\" style=\"color{black}; font-weight: bold;\">Carbon Policy</a>.",
                    "savings_current_toolkit": "*{currentSavings} kg CO<sub>2</sub> from current toolkit."
                }
            }
        },
        "emails": {
            "toolkit_submitted": {
                "email_subject": "Cyflwyno'r Celfyddydau",
                "hello": "Helo {team}",
                "subject_org": "Mae eich pecyn celfyddydau {toolkit} ar gyfer {organisation} fel rhan o {programme} wedi cael ei gyflwyno!",
                "subject_prog": "Mae eich pecyn celfyddydau {toolkit} fel rhan o {programme} wedi cael ei gyflwyno!",
                "retractable": "Os gwnaethoch chi gamgymeriad, neu os hoffech chi ychwanegu mwy o wybodaeth am eich gweithredoedd, gallwch dynnu eich cyflwyniad yn ôl yn adran y phecynnau yn eich cyfrif.",
                "locked": "Mae eich pecyn celfyddydau wedi'i gloi erbyn hyn, felly os gwnaethoch chi gamgymeriad, neu os hoffech chi ychwanegu mwy o wybodaeth am eich gweithredoedd,",
                "email_admins": "e-bostiwch eich gweinyddwyr ar",
                "email": "e-bostiwch",
                "auditor": "Bydd archwilydd yn cysylltu â gweinydd eich tîm yn fuan!",
                "sign_off": "Diolch,<br>Tîm SOS-UK."
            },
            "toolkit_submitted_admin": {
                "email_subject": "Toolkit Submitted",
                "hello": "Hello!",
                "subject_org": "A {toolkit} toolkit for {organisation} as part of {programme} has been submitted for the team {team}!",
                "subject_prog": "A {toolkit} toolkit as part of {programme} has been submitted for the team {team}!",
                "retractable": "The team can still retract their submission in the toolkits section of their account.",
                "locked": "This team's toolkit is now locked, so they will need to contact you to make any alterations.",
                "auditor": "An auditor will be in touch with the team's admin soon!",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "toolkit_joined": {
                "email_subject": "Toolkit Joined",
                "hello": "Hello {team}",
                "fallback_content": "You have successfully joined a new toolkit!",
                "toolkit_details_header": "Your toolkit details are:",
                "toolkit_details_org": "{toolkit} toolkit for {organisation} as part of {programme}",
                "toolkit_details_prog": "{toolkit} toolkit for {organisation} as part of {programme}",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "toolkit_joined_admin": {
                "email_subject": "Toolkit Joined",
                "hello": "Hello!",
                "fallback_content": "A team has successfully joined a toolkit!",
                "team_details": "Team: {team}",
                "toolkit_details_org": "Toolkit: {toolkit} toolkit for {organisation} as part of {programme}",
                "toolkit_details_prog": "Toolkit: {toolkit} toolkit for {organisation} as part of {programme}",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "team_invite": {
                "email_subject": "Gwahoddiad i Dîm",
                "subject": "Rydych chi wedi cael eich gwahodd i ymuno â thîm {team}!",
                "register": "Os nad oes gennych chi gyfrif, gallwch ei greu drwy glicio'r botwm isod. Ar ôl creu cyfrif, gallwch glicio ar y botwm derbyn gwahoddiad yn yr e-bost hwn i dderbyn y gwahoddiad i'r tîm:",
                "create_account": "Creu Cyfrif",
                "accept_1": "Os oes gennych chi gyfrif eisoes, gallwch dderbyn y gwahoddiad hwn drwy glicio ar y botwm isod:",
                "accept_2": "Gallwch dderbyn y gwahoddiad hwn drwy glicio ar y botwm isod:",
                "accept_invitation": "Derbyn Gwahoddiad",
                "discard": "Os na fyddai chi yn disgwyl derbyn gwahoddiad i'r tîm hwn, gallwch ddisgynnu'r e-bost hwn."
            },
            "password_reset": {
                "email_subject": "Gwybodaeth Ailosod Cyfrinair",
                "subject": "Rydych chi'n derbyn yr e-bost hwn gan fod gweinyddwr wedi ailosod cyfrinair eich cyfrif.",
                "password": "Eich cyfrinair newydd yw: {password}",
                "sign_in": "Byddem yn argymell i chi fewngofnodi i'ch cyfrif a newid hyn i rywbeth y gallwch ei gofio.",
                "sign_off": "Diolch,<br>Tîm SOS-UK."
            },
            "password_reset_request": {
                "greeting": "Helo!",
                "subject": "Gwybodaeth Ailosod Cyfrinair",
                "line_1": "Rydych chi'n derbyn yr e-bost hwn gan ein bod wedi derbyn cais i ailosod cyfrinair eich cyfrif.",
                "line_2": "Cliciwch ar y botwm isod i ailosod eich cyfrinair:",
                "button": "Ailosod Cyfrinair",
                "expire": "Bydd y ddolen ailosod cyfrinair hon yn dod i ben mewn {count} munudau",
                "notice": "Os na wnaethoch chi wneud cais i ailosod eich cyfrinair, ni fydd angen cymryd unrhyw gamau pellach. Nodwch fod y ddolen ailosod cyfrinair hon yn ddilys am un awr yn unig.",
                "sign_off": "Diolch,<br>Tîm SOS-UK."
            },
            "verify_password": {
                "email_subject": "E-bost Dilysu Defnyddiwr",
                "subject": "Cliciwch ar y botwm isod i wirio eich cyfeiriad e-bost.",
                "expire": "Bydd y ddolen ailosod cyfrinair hon yn dod i ben mewn {count} munudau",
                "button": "Dilysu Cyfeiriad E-bost",
                "notice": "Os nad ydych chi wedi creu cyfrif, ni fydd angen cymryd unrhyw gamau pellach.",
                "sign_off": "Diolch,<br>Tîm SOS-UK."
            },
            "promote_user": {
                "subject": "Your have been promoted to Team Admin for the {team_name} team.",
                "greeting": "Hello",
                "promoted": "You have been promoted to Team Admin for the team {team_name} on the {toolkit} toolkit as part of {programme}.",
                "promoted_gi": "You have been promoted to Team Admin for the team {team_name} on the {toolkit} toolkit for {organisation} as part of {programme}.",
                "reason": "This happened when the current team Admin left the platform and nominated you to take over this role. You can now manage your team on the {link} page.",
                "sign_off": "Thanks,<br>The SOS-UK Team.",
                "promoted_no_toolkit": "You have been promoted to Team Admin for the team {team_name} on the SOS Toolkit."
            },
            "gdpr_removal": {
                "subject": "A user has requested removal of their associated data from the system.",
                "greeting": "Hello",
                "body": "A user has deleted their account and requested that any associated data be removed from the system. There details are",
                "name": "name",
                "email": "email",
                "user_id": "User ID",
                "time_period": "The user should be contacted about their data removal within one calendar month",
                "sign_off": "Thanks,<br>The SOS-UK Platform."
            },
            "exports": {
                "report": {
                    "email_subject": "{type} Report ready to Download!",
                    "subject": "Your {type} Report is ready to download. The download link will be valid for 1 week.",
                    "button": "Download Report",
                    "email_subject_failed": "{type} Report failed",
                    "subject_failed": "Your {type} Report failed. Please log in and try again.",
                    "sign_off": "Thanks,<br>The SOS-UK Team."
                }
            },
            "reporting": {
                "password_reset": {
                    "email_subject": "A Reporting Supervisor has requested a password reset"
                }
            },
            "team_deletion": {
                "email_subject_team_deletion_reminder": "Reminder - your team {team} is scheduled to be deleted tomorrow",
                "email_subject_team_deleted": "Confirmation - your team {team} has now been deleted",
                "email_subject_team_scheduled_for_deletion": "Your team {team} has been scheduled for deletion"
            }
        },
        "teams": {
            "create": {
                "details": "Manylion y Tîm",
                "title": "Creu Tîm",
                "description": "Creu tîm newydd i gydweithio ag eraill ar brosiectau.",
                "create": "Creu",
                "name": "Enw’r {team_name}",
                "create_team": "Creu {team_name}"
            },
            "questions": {
                "title": "Gwybodaeth Ychwanegol",
                "info": "Atebwch y cwestiynau ychwanegol canlynol am eich {team_name}.",
                "option": "-- Dewiswch opsiwn --",
                "warning": "Mae gennych rai cwestiynau heb eu hateb. Adolygwch y cwestiynau isod ac atebwch unrhyw gwestiynau sydd wedi’u marcio’n wag fel sydd angen.",
                "saved": "Atebion wedi’u harbed yn llwyddiannus.",
                "error": "Aeth rhywbeth o chwith.",
                "required": "Sylwer bod  <span class=\"required-form-field\">*</span> yn dynodi maes angenrheidiol.",
                "save": "Arbed"
            },
            "delete": {
                "title": "Dileu {team_name}",
                "description": "Dileu’r {team_name} hwn yn barhaol.",
                "warning": "Once a {team_name} is deleted, all of its resources and data will be permanently deleted. Before deleting this {team_name}, please download any data or information regarding this {team_name} that you wish to retain.",
                "confirmation": "Ydych chi’n sicr eich bod am ddileu’r {team_name} hwn? Unwaith y bydd {team_name} wedi’i ddileu",
                "cancel": "Canslo",
                "confirm": "Schedule {team_name} Deletion",
                "cancel_scheduled_deletion": "Cancel scheduled deletion",
                "scheduled_deletion_date_text": "This {team_name} is scheduled for deletion on <strong>{scheduled_deletion_date}</strong>.  To cancel this scheduled deletion, click on button below:",
                "scheduled_for_deletion_title": "Scheduled for deletion",
                "confirmation_checkbox_label": "I am sure I want to delete this {team_name}",
                "no_delete_permission": "Only team admins are able to schedule a team for deletion. If your team is scheduled for deletion by one of the admins you will be notified by email and will be able to cancel the request here."
            },
            "join": {
                "programmes": {
                    "title": "Ymuno â rhaglen",
                    "teams": "ar gyfer Timau",
                    "individuals": "ar gyfer Unigolion"
                },
                "teams": {
                    "title": "Ymunwch neu greu {team_name}",
                    "info": "Os nad yw eich {team_name} yn bodoli eisoes, gallwch greu {team_name} newydd sbon",
                    "join": "Ymunwch â {team_name}"
                }
            },
            "members": {
                "title": "Aelodau’r",
                "description": "Pawb sy’n rhan o’r {team_name} hwn.",
                "info": "A team must have at least one administrator. If you are the sole administrator and want to leave a team, please promote another member to administrator first.",
                "leave": "Gadael",
                "owner": "Perchennog",
                "remove": "Dileu",
                "add": {
                    "title": "Ychwanegu Aelod o’r {team_name}",
                    "description": "Ychwanegu aelod newydd i’ch {team_name}.",
                    "info": "Nodwch gyfeiriad e-bost y person rydych am ei ychwanegu at y {team_name} hwn.",
                    "form": {
                        "email": "E-bost",
                        "role": "Rôl",
                        "submit": "Ychwanegu",
                        "success": "Wedi’i ychwanegu."
                    }
                },
                "pending": {
                    "title": "Gwahoddiadau i’r Tîm sydd Ar y Gweill",
                    "description": "Mae’r bobl hyn wedi cael eu gwahodd i’ch tîm, ac mae e-bost gwahoddiad wedi’i anfon atynt. Gallant ymuno â’r tîm drwy dderbyn y gwahoddiad e-bost.",
                    "cancel": "Canslo"
                },
                "role": {
                    "title": "Rheoli’r Rôl",
                    "cancel": "Canslo",
                    "save": "Arbed"
                },
                "leave-modal": {
                    "title": "Gadael y Tîm",
                    "warning": "Ydych chi’n sicr eich bod am adael y tîm hwn?",
                    "cancel": "Canslo",
                    "confirm": "Gadael"
                },
                "remove-modal": {
                    "title": "Diddymu Aelod o’r Tîm",
                    "warning": "Ydych chi’n sicr eich bod am ddileu’r person yma o’r tîm.",
                    "cancel": "Canslo",
                    "confirm": "Dileu"
                }
            },
            "update": {
                "title": "Enw’r {team_name}",
                "description": "Enw’r {team_name} a gwybodaeth am y perchennog.",
                "owner": "Perchennog y {team_name}",
                "name": "Enw’r {team_name}",
                "success": "Wedi arbed",
                "submit": "Arbed"
            },
            "carbon_savings": {
                "title": "Carbon Savings",
                "description": "Opt your {team_name} into or out of seeing carbon saving information.",
                "toggle": "Enable Carbon Savings information for my {team_name}",
                "success": "Wedi arbed",
                "submit": "Arbed"
            },
            "settings": {
                "title": "Gosodiadau’r {team_name}"
            }
        },
        "toolkit": {
            "toolkit": "Pecyn cymorth",
            "intro_text": "Gellir gweld yr holl weithrediadau sydd ar gael yn eich pecyn cymorth isod. Ni fydd yr holl weithrediadau o reidrwydd yn berthnasol i chi, felly gallwch ddefnyddio’r hidlyddion i ddod o hyd i’r gweithrediadau. Gallwch hefyd osod seren wrth weithrediadau i’w cyrchu’n hawdd ar eich dangosfwrdd, a phenu gweithrediadau ar gyfer aelodau eraill o’r {team_name} (bydd gweithrediadau a bennwyd hefyd yn ymddangos ar y dangosfwrdd).",
            "team": "Tîm",
            "submit": "Cyflwyno’r Pecyn Cymorth",
            "no_toolkits": "Does dim pecynnau cymorth gweithredol ar gael i ymuno â nhw ar hyn o bryd. Gwiriwch yn nes ymlaen.",
            "join": {
                "title": "Ymuno â phecyn cymorth",
                "button": "Ymuno â phecyn cymorth"
            },
            "past": {
                "title": "Pecynnau cymorth blaenorol",
                "none": "Nid yw eich {team_name} wedi cyfranogi mewn unrhyw becynnau cymorth hyd yma.",
                "retract": "Retract Submission",
                "status": "Statws",
                "actions": "Gweithrediadau",
                "score": "Sgôr",
                "view": "View Toolkit",
                "completed_points": "Completed Points",
                "completed_actions": "Completed Actions",
                "out_of": "out of a possible",
                "awards": "Awards obtained",
                "not_applicable": "N/A",
                "awaiting_audit": "Awaiting Audit",
                "audit_in_progress": "Audit in progress",
                "action_required": "Action required",
                "audited": "Audited",
                "toolkit_submitted": "Submitted",
                "toolkit_completed": "Completed",
                "toolkit_incomplete": "Incomplete (Expired)",
                "toolkit_locked": "Locked",
                "toolkit_locked_warning": "This toolkit has been locked. You can no longer make changes to it.",
                "adminToolkit": "You are viewing this toolkit as an admin and cannot make changes to it.",
                "readOnly": "This is not a currently active toolkit and you cannot make changes to it. To view or join a current toolkit please <a href=\"{link}\" style=\"color{black}\">click here</a>."
            },
            "submission": {
                "title": "Cyflwyno pecyn cymorth",
                "prompt": "Ydych chi’n sicr eich bod am gyflwyno’r pecyn cymorth hwn?",
                "warning": "Ni fyddwch chi ac aelodau’ch {team_name} yn gallu newid unrhyw wybodaeth mwyach ar ôl cyflwyno’r pecyn cymorth.",
                "name_change": "Ydych chi am newid enw eich {team_name} cyn cyflwyno?",
                "cancel": "Canslo",
                "submit": "Cyflwyno",
                "submitted": "Pecyn Cymorth wedi’i Gyflwyno",
                "congratulations": "Llongyfarchiadau {team}!",
                "details_1": "Rydych chi wedi cyflwyno’r pecyn cymorth",
                "details_2": "ar gyfer",
                "details_3": "fel rhan o",
                "details_4": "Bydd eich atebion nawr yn cael eu harchwilio, a byddwn yn cysylltu â chi gyda mwy o fanylion yn fuan. Yn y cyfamser, gallwch ymlacio a theimlo rhywfaint o foddhad."
            },
            "nav": {
                "language_full": "Iaith"
            },
            "preview": {
                "preview_mode_short": "Rydych yn y modd Rhagolwg",
                "preview_mode_long": "Rydych ar hyn o bryd yn y modd Rhagolwg",
                "team": "Tîm enghreifftiol"
            },
            "action": {
                "inactive": "Nid yw’r gweithrediad hwn bellach yn weithredol ar y pecyn cymorth.",
                "criteria_tab": "Meini prawf",
                "information_tab": "Gwybodaeth bellach",
                "audited_tab": "Sut fyddwch chi’n cael eich archwilio",
                "comments_tab": "Sylwadau a thystiolaeth",
                "comments": "Sylwadau",
                "save_comment": "Arbed",
                "evidence": "Tystiolaeth",
                "add_evidence": "Ychwanegu",
                "custom_fields": "Meysydd Unigryw",
                "total_points": "Cyfanswm Pwyntiau",
                "assigned_to": "Wedi’u pennu ar gyfer",
                "unassigned": "Heb eu pennu",
                "assign": "Pennu i ddefnyddiwr",
                "evidence_upload": {
                    "title": "Uwchlwytho Tystiolaeth i Weithrediad",
                    "warning": "Peidiwch ag uwchlwytho unrhyw ffeiliau a all gynnwys data sensitif neu bersonol!",
                    "cancel": "Canslo",
                    "confirm": "Uwchlwytho"
                },
                "carbon_savings": {
                    "title": "Carbon Savings",
                    "saving": "This action could save",
                    "co2": "{carbon_total} kg CO<sub>2</sub>"
                }
            },
            "filters": {
                "area": "Maes",
                "award_level": "Lefel Gwobr",
                "theme": "Thema",
                "status": "Statws",
                "assigned_to": "Wedi’u pennu ar gyfer",
                "sdg": "SDG",
                "starred": "Â seren",
                "count": "Gweld {length} o ganlyniadau ar sail hidlyddion a ddefnyddir ar hyn o bryd."
            },
            "comment": {
                "deleted": "sylw wedi’i ddileu gan y Gweinyddwr",
                "added_by": "sylw wedi’i ychwanegu gan",
                "delete_confirm_title": "Cadarnhewch os gwelwch yn dda!",
                "delete_warning": "Ydych chi’n sicr eich bod am ddileu’r sylw hwn?",
                "delete_cancel": "Canslo",
                "delete_confirm": "Dileu",
                "last_updated": "Last updated"
            },
            "custom_field": {
                "required": "Mae angen cwblhau’r maes hwn. Ni allwch arbed os yw’n wag.",
                "empty": "Ni allwch arbed maes gwag.",
                "saved_date": "Dyddiad a arbedwyd",
                "save": "Arbed"
            },
            "evidence": {
                "uploaded_by": "uwchlwythwyd gan",
                "delete_confirm_title": "Cadarnhewch os gwelwch yn dda!",
                "delete_warning": "Ydych chi’n sicr eich bod am ddileu’r ffeil hon?",
                "delete_cancel": "Canslo",
                "delete_confirm": "Dileu"
            },
            "sort": {
                "sort_by_filter": "Didoli drwy hidlo",
                "sort_direction": "Cyfeiriad didoli",
                "asc": "Trefn esgynnol",
                "desc": "Trefn ddisgynnol",
                "sort": "Didoli"
            },
            "export": {
                "title": "Allgludo Gweithrediadau fel Gweithlyfr Excel",
                "print": "Argraffu camau"
            }
        },
        "user": {
            "title": "Proffil",
            "delete": {
                "title": "Dileu Cyfrif",
                "description": "Dileu eich cyfrif yn barhaol.",
                "info": "Unwaith y bydd eich cyfrif wedi’i ddileu, bydd ei holl adnoddau a data yn cael eu dileu yn barhaol. Cyn dileu eich cyfrif, lawrlwythwch unrhyw ddata neu wybodaeth yr hoffech eu cadw.",
                "delete_button": "Dileu Cyfrif",
                "warning": "Ydych chi’n sicr eich bod am ddileu’ch cyfrif? Unwaith y bydd eich cyfrif wedi’i dileu bydd ei holl adnoddau a data yn cael eu dileu yn barhaol. Rhowch eich cyfrin-air i gadarnhau yr hoffech ddileu eich cyfrif yn barhaol.",
                "password": "Cyfrin-air",
                "cancel": "Canslo",
                "confirm": "Dileu Cyfrif",
                "permanent": {
                    "title": "Dileu eich cyfrif yn barhaol",
                    "description": "Dileu eich cyfrif yn barhaol",
                    "info": "Ni allwch ddileu eich cyfrif os ydych yn berchen ar dîm sydd heb unrhyw ddefnyddwyr Gweinyddol.",
                    "admin_change_1": "Newidiwch aelod o’r tîm i rôl Weinyddol ar y dudalen.",
                    "admin_change_2": "Gallwch wedyn enwebu’r defnyddiwr yma i ddod yn berchennog y tîm pan fyddwch chi’n dileu eich cyfrif.",
                    "admin_change_link": "Gosodiadau’r Tîm"
                },
                "soft": {
                    "info": "Os nad ydych bellach am fod yn rhan o’r llwyfan hwn, gallwch ddileu eich cyfrif a bydd unrhyw ddata rydych wedi’i gyfrannu’n cael ei wneud yn ddienw.",
                    "button": "Dileu fy Nghyfrif"
                },
                "hard": {
                    "info": "Gallwch wneud cais i gael eich cyfrif wedi’i ddileu, ynghyd ag unrhyw gynnwys rydych chi wedi’i greu.",
                    "button": "Cais am ddileu eich cyfrif a data cysylltiedig"
                },
                "modal": {
                    "title": "Dileu’r Cyfrif",
                    "owner": "Gan mai chi yw perchennog y tîm, bydd angen i chi aseinio perchnogaeth tîm i ddefnyddiwr gweinyddol arall.",
                    "placeholder": "Pennu Rôl Perchennog y Tîm",
                    "warning": "Ydych hi’n sicr eich bod am ddileu eich cyfrif? Nodwch eich cyfrin-air i gadarnhau eich bod am ddileu eich cyfrif yn barhaol.",
                    "info": "Gwneir cais i ddiddymu eich data cysylltiedig. Byddwn yn cysylltu â chi ynglŷn â hyn ymhen un mis calendr.",
                    "team_removal": "Gan mai chi yw unig aelod eich tîm, bydd eich tîm hefyd yn cael ei ddileu.",
                    "password": "Cyfrin-air ",
                    "cancel": "Canslo",
                    "confirm": "Dileu’r Cyfrif"
                }
            },
            "browser_sessions": {
                "title": "Sesiynau Porwr",
                "description": "Rheoli ac allgofnodi o’ch sesiynau byw ar borwyr a dyfeisiadau eraill.",
                "info": "Os oes angen, gallwch allgofnodi o’ch holl sesiynau porwr eraill ar draws eich holl ddyfeisiau. Rhestrir rhai o’ch sesiynau diweddar isod; fodd bynnag, efallai na fydd y rhestr hon yn hollgynhwysfawr. Os ydych chi’n teimlo bod eich cyfrif wedi’i beryglu, dylech chi hefyd ddiweddaru’ch cyfrin-air.",
                "device": "Y ddyfais hon",
                "active": "Yn weithredol ddiwethaf",
                "logout_button": "Allgofnodi o Sesiynau Porwyr Eraill",
                "done": "Wedi gwneud",
                "logout_title": "Allgofnodi o Sesiynau Porwyr Eraill",
                "logout_confirmation": "Nodwch eich cyfrin-air i gadarnhau eich bod am allgofnodi o’ch sesiynau porwyr eraill ar draws eich holl ddyfeisiadau.",
                "logout_password": "Cyfrin-air",
                "logout_cancel": "Canslo",
                "logout_confirm": "Allgofnodi o Sesiynau Porwyr Eraill"
            },
            "2fa": {
                "title": "Dilysiad Dau Ffactor",
                "description": "Ychwanegwch ddiogelwch at eich cyfrif drwy ddefnyddio dilysiad dau ffactor.",
                "enabled": "You have enabled two factor authentication.",
                "finish_enabling": "Finish enabling two factor authentication.",
                "not_enabled": "Rydych wedi galluogi dilysiad dau ffactor.",
                "info": "Pan fo dilysiad dau ffactor wedi’i alluogi, fe’ch anogir am docyn diogel, ar hap yn ystod y dilysu. Gallwch adfer y tocyn hwn o raglen Google Authenticator eich ffôn.",
                "enable_instructions": " I orffen galluogi dilysiad dau ffactor, sganiwch y côd QR canlynol gan ddefnyddio system ddilysu eich ffôn neu pwyswch y nod gosod-i-fyny a darparu’r côd OTP sydd wedi’i greu.",
                "finished_instructions": "Mae dilysiad dau ffactor nawr wedi’i alluogi. Sganiwch y côd QR canlynol gan ddefnyddio system ddilysu eich ffôn neu pwyswch y nod gosod-i-fyny.",
                "setup_key": "Nod Gosod-i-fyny:",
                "code": "Côd",
                "recovery_code_info": "Storiwch y codau adfer hyn mewn rheolwr cyfrin-eiriau diogel. Gellir eu defnyddio i adfer mynediad i’ch cyfrif os caiff eich dilysiad dau ffactor ei golli.",
                "enable_button": "Galluogi",
                "confirm_button": "Cadarnhau",
                "regenerate_recovery_codes_button": "Ailgreu Codau Adfer",
                "show_recovery_codes_button": "Dangos Codau Adfer",
                "cancel": "Canslo",
                "disable": "Anablu"
            },
            "password": {
                "title": "Diweddaru Cyfrin-air",
                "description": "Defnyddiwch gyfrin-air hir a chymhleth i ddiogelu’ch cyfrif",
                "current_password": "Cyfrin-air Presennol",
                "new_password": "Cyfrin-air Newydd",
                "confirm_password": "Cadarnhau Cyfrin-air",
                "success": "Wedi arbed",
                "submit": "Arbed"
            },
            "profile": {
                "title": "Gwybodaeth Proffil",
                "description": "Diweddarwch wybodaeth proffil a chyfeiriad e-bost eich cyfrif",
                "photo": "Llun",
                "photo_button": "Dewiswch Lun Newydd",
                "remove_photo_button": "Dileu Llun",
                "first_name": "Enw Cyntaf",
                "last_name": "Enw Olaf",
                "email": "E-bost",
                "email_unverified": "Ni ellir cadarnhau eich cyfeiriad e-bost.",
                "email_unverified_button": "Cliciwch yma i ail-anfon e-bost cadarnhau.",
                "email_verification_sent": "Mae dolen gadarnhau newydd wedi’i hanfon i’ch cyfeiriad e-bost.",
                "preferred_language": "Dewis Iaith",
                "success": "Wedi arbed",
                "submit": "Arbed"
            },
            "information": {
                "title": "Gwybodaeth ychwanegol",
                "description": "Gallwch gyrchu a golygu gwybodaeth proffil defnyddiwr ychwanegol yma.",
                "edit": "Golygu gwybodaeth ychwanegol"
            },
            "questions": {
                "title": "Gwybodaeth Proffil Ychwanegol",
                "info": "Os ydych chi newydd gofrestru, unwaith y byddwch chi wedi llenwi’r cwestiynau angenrheidiol isod, gallwch ymuno â thîm drwy fynd i’r pecyn cymorth yn y ddewislen.",
                "saved": "Atebion wedi’u harbed yn llwyddiannus.",
                "description": "Atebwch y cwestiynau ychwanegol canlynol os gwelwch yn dda.",
                "required": "Sylwer bod <span class=\"required-form-field\">*</span> yn dynodi maes sydd angen ei lenwi.",
                "save": "Arbed",
                "not_requested": "Does dim cais wedi’i wneud am wybodaeth ychwanegol ar hyn o bryd"
            }
        }
    },
    "en": {
        "admin": {
            "welcome": "Welcome",
            "warning": "Warning",
            "cancel": "Cancel",
            "continue": "Continue",
            "reset_and_send_confirm": "You are about to reset this user's password",
            "reset_email_confirm": "You are about to send this user a Reset password email",
            "reset_email_confirm_not_title": "Reset email not sent",
            "reset_email_confirm_not_message": "There was a problem and the password reset email was not sent",
            "reset_and_send_confirm_not_title": "Password not reset",
            "reset_and_send_confirm_not_message": "There was a problem and the user's password was not reset",
            "activate_toolkit": "If you activate this toolkit, other active {Type} toolkits for this {affiliation} will be deactivated",
            "deactivate_toolkit": "If you deactivate this toolkit, there will be no active {Type} toolkits for this {affiliation}",
            "delete_comment": "Are you sure you want to delete this comment?"
        },
        "application": {
            "welcome": {
                "content": "Thank you for visiting our toolkit platform. You have reached this page in error. To access the toolkit for your programme, please use the full URL. If you are not sure what your programme's URL is, please contact <a href=\"mailto:toolkit@sos-uk.org\">toolkit@sos-uk.org</a>.",
                "logo": "Logo"
            },
            "navigation": {
                "manage_account": "Manage Account",
                "profile": "Profile",
                "api_tokens": "API Tokens",
                "log_out": "Log Out",
                "manage_team": "Manage {team_name}",
                "team_settings": "{team_name} Settings",
                "switch_toolkits": "Switch Toolkits",
                "clear_selection": "Clear Selection"
            },
            "general": {
                "cancel": "Cancel",
                "password": "Password",
                "error": "Whoops! Something went wrong.",
                "find_on_social_media": "Find {name} on social media:"
            },
            "email_validation": {
                "title": "To continue, please validate your email address.",
                "info": "You should have received an email at the address you used when registering, please enter the registration code in the email below.",
                "submit": "Submit",
                "resend": "If you did not receive an email, you can try resending the validation email:",
                "resend_button": "Send validation email again"
            },
            "email_verification": {
                "info": "Before continuing, could you verify your email address by clicking on the link we just emailed to you? If you didn't receive the email, we will gladly send you another.",
                "link_sent": "A new verification link has been sent to the email address you provided in your profile settings.",
                "resend_button": "Resend Verification Email"
            },
            "auth": {
                "confirm_password": "This is a secure area of the application. Please confirm your password before continuing.",
                "confirm": "Confirm",
                "forgot_password": "Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.",
                "email": "Email",
                "email_password": "Email Password Reset Link",
                "reset_password": "Reset your password",
                "no_content": "Sorry, there is nothing here at the moment. Please return to the <Link href=\"/\" style=\"color{black}\">home page </Link> and try again.",
                "confirm_password_label": "Confirm Password",
                "reset_password_button": "Reset password",
                "log_in": "Log In",
                "2fa": {
                    "recovery": "Please confirm access to your account by entering the authentication code provided by your authenticator application.",
                    "confirm": "Please confirm access to your account by entering one of your emergency recovery codes.",
                    "code": "Code",
                    "recovery_code": "Recovery Code",
                    "recovery_title": "Use a recovery code",
                    "authentication_title": "Use an authentication code"
                }
            }
        },
        "auditor": {
            "login": {
                "code": "Auditor Code",
                "name": "Auditor Name"
            },
            "team": {
                "title": "Welcome",
                "toolkits_audit": "You are auditing toolkits for",
                "assigned_team": "Your assigned team is",
                "select_team": "Please select the team you will be auditing below.",
                "view_toolkit_button": "View team toolkit"
            },
            "submit": "Submit Audit",
            "evidence": "Download All Evidence (.zip)",
            "action": {
                "comments": "Auditor Comments",
                "actions": "Auditor Actions",
                "accept_status": "Accept Status",
                "accepted": "Status Accepted",
                "further_evidence_required": "Further Evidence Required",
                "suggested_status_change": "Suggested Status Change: ",
                "suggested_points_change": "Suggested Points Change: ",
                "change_points_value": "Change Action Points Value",
                "change_points_value_button": "Go",
                "download_evidence": "Download Evidence (.zip)"
            },
            "toolkit": {
                "auditor_team_questions_heading": "Please ask the team the following questions during the audit",
                "auditor_show_team_questions": "Show Team Questions",
                "auditor_hide_team_questions": "Hide Team Questions"
            },
            "submit_audit": {
                "heading": "Submit Audit",
                "prompt": "Are you sure you want to submit this audit?",
                "warning": "You will no longer be able to edit any audit information after submission.",
                "reminder": "Please remember to answer any questions in the Team Questions section.",
                "cancel": "Cancel",
                "submit": "Submit Audit"
            },
            "auditor_questions": {
                "auditor_questions_heading": "Thanks {auditor}! Before you go...",
                "auditor_questions_introduction": "It would be great if you could answer the below questions about your auditing experience.",
                "auditor_questions_save_reminder": "Please remember to save your answers.",
                "auditor_questions_submit_feedback": "Submit feedback",
                "auditor_questions_error_message": "Something went wrong. Have you checked all required fields have been filled in?",
                "complete_audit": "Complete Audit"
            },
            "audit_complete": {
                "audit_complete_heading": "Audit Complete!",
                "audit_complete_thankyou": "Thank you for taking the time to audit {team}.",
                "audit_complete_notice": "Please ensure that all downloaded files are removed from your machine now.",
                "audit_another_team": "Audit another team",
                "sign_out": "Sign out",
                "enter_another_code": "Enter another code"
            }
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "dashboard": {
            "login": {
                "email": "Email",
                "password": "Password",
                "logged_in": "Keep me logged in",
                "forgot": "Forgot your password?",
                "log_in": "Log In",
                "not_a_member": "Not a member yet?",
                "register": "Register",
                "home": "Home",
                "no_organisation": "Sorry, you need to specify an organisation to log in to this programme."
            },
            "register": {
                "first_name": "First Name",
                "last_name": "Last Name",
                "email": "Email",
                "password": "Password",
                "confirm_password": " Confirm Password",
                "password_rules": "Your password must be at least 10 characters long and contain at least one special character and one number.",
                "agree": "I agree to the ",
                "privacy_policy": "Privacy Policy",
                "registered": "Already registered?",
                "register": "Register",
                "no_organisation": "Sorry, you need to specify an organisation to register on this programme."
            },
            "title": "Dashboard",
            "greeting": "Hello, {name}",
            "intro_text": "Access your toolkit on the left hand menu.",
            "sidebar": {
                "dashboard": "Dashboard",
                "toolkit": "Toolkit"
            },
            "widgets": {
                "shared": {
                    "status": {
                        "done": "Done",
                        "in_progress": "In progress",
                        "not_done": "Not Done",
                        "not_applicable": "N/A",
                        "none": "No Status"
                    }
                },
                "starred": {
                    "title": "Starred Actions",
                    "empty": "You currently have no starred actions to display."
                },
                "assigned": {
                    "title": "Assigned Actions",
                    "empty": "You currently have no assigned actions to display."
                },
                "leaderboard": {
                    "title": "Leaderboard",
                    "intro_text": "Top ten",
                    "points": "by number of points achieved",
                    "actions": "by number of actions completed",
                    "position": "Show me my {team_name}'s league position",
                    "empty": "You currently have no content to display."
                },
                "awards": {
                    "title": "Awards Progress",
                    "empty": "There are no awards to show at this time.",
                    "intro_text": "View your {team_name}'s progress towards completing this Toolkit's awards.",
                    "points_score_status": "Your {team_name} has completed <strong>{totalCompletedActions}</strong> actions so far, totalling <strong>{totalPoints}</strong> points.",
                    "actions_score_status": "Your {team_name} has completed <strong>{totalCompletedActions}</strong> actions so far.",
                    "obtain": "Obtain",
                    "complete": "Complete",
                    "or_more": "or more",
                    "points": "points",
                    "between": "between",
                    "and": "and",
                    "award": "award",
                    "all": "all",
                    "from": "from",
                    "of": "of",
                    "tagged_actions": "actions tagged with this award",
                    "including_na": "(Including N/A)"
                },
                "new_toolkit": {
                    "new": "New",
                    "content": "There is a new toolkit available to join."
                },
                "previous_toolkits": {
                    "title": "Previous Toolkits"
                },
                "carbon_savings": {
                    "title": "Carbon Savings",
                    "savings_prepend": "Your {team_name} has saved<br />an estimated ",
                    "savings_append": " kg CO<sub>2</sub> so far.*",
                    "savings_text_1": "The carbon saving estimates provided by this online calculator are based on a set of assumptions and general estimates to display an approximate idea of potential carbon savings from specific actions. While the results may not reflect precise savings in every scenario, they serve as a valuable tool to illustrate how certain choices can contribute to reducing carbon footprints. The calculations aim to help teams visualise the impact of adopting more sustainable practices, offering a clearer picture of the positive environmental effects that these efforts could potentially achieve.",
                    "savings_text_2": "No prey, no pay crow's nest nipper jury mast holystone Barbary Coast loot Arr broadside cutlass. Plate Fleet Gold Road grog fore chase Letter of Marque lee parrel black jack line. Brig Barbary Coast gunwalls Pieces of Eight quarterdeck square-rigged belay Buccaneer bilge water doubloon.",
                    "carbon_policy": "Read more about carbon savings in our <a href=\"{link}\" style=\"color{black}; font-weight: bold;\">Carbon Policy</a>.",
                    "savings_current_toolkit": "*{currentSavings} kg CO<sub>2</sub> from current toolkit."
                }
            }
        },
        "emails": {
            "toolkit_submitted": {
                "email_subject": "Toolkit Submitted",
                "hello": "Hello {team}",
                "subject_org": "Your {toolkit} toolkit for {organisation} as part of {programme} has been submitted!",
                "subject_prog": "Your {toolkit} toolkit as part of {programme} has been submitted!",
                "retractable": "If this was a mistake, or you would like to add more information to your actions, you can retract your submission in the toolkits section of your account.",
                "locked": "Your toolkit is now locked, so if this was a mistake, or you would like to add more information to your actions,",
                "email_admins": "please email your admin(s) at",
                "email": "please email",
                "auditor": "An auditor will be in touch with your team's admin soon!",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "toolkit_submitted_admin": {
                "email_subject": "Toolkit Submitted",
                "hello": "Hello!",
                "subject_org": "A {toolkit} toolkit for {organisation} as part of {programme} has been submitted for the team {team}!",
                "subject_prog": "A {toolkit} toolkit as part of {programme} has been submitted for the team {team}!",
                "retractable": "The team can still retract their submission in the toolkits section of their account.",
                "locked": "This team's toolkit is now locked, so they will need to contact you to make any alterations.",
                "auditor": "An auditor will be in touch with the team's admin soon!",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "toolkit_joined": {
                "email_subject": "Toolkit Joined",
                "hello": "Hello {team}",
                "fallback_content": "You have successfully joined a new toolkit!",
                "toolkit_details_header": "Your toolkit details are:",
                "toolkit_details_org": "{toolkit} toolkit for {organisation} as part of {programme}",
                "toolkit_details_prog": "{toolkit} toolkit for {organisation} as part of {programme}",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "toolkit_joined_admin": {
                "email_subject": "Toolkit Joined",
                "hello": "Hello!",
                "fallback_content": "A team has successfully joined a toolkit!",
                "team_details": "Team: {team}",
                "toolkit_details_org": "Toolkit: {toolkit} toolkit for {organisation} as part of {programme}",
                "toolkit_details_prog": "Toolkit: {toolkit} toolkit for {organisation} as part of {programme}",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "team_invite": {
                "email_subject": "Team Invitation",
                "subject": "You have been invited to join the {team} team!",
                "register": "If you do not have an account, you may create one by clicking the button below. After creating an account, you may click the invitation acceptance button in this email to accept the team invitation:",
                "create_account": "Create Account",
                "accept_1": "If you already have an account, you may accept this invitation by clicking the button below:",
                "accept_2": "You may accept this invitation by clicking the button below:",
                "accept_invitation": "Accept Invitation",
                "discard": "If you did not expect to receive an invitation to this team, you may discard this email."
            },
            "password_reset": {
                "email_subject": "Reset Password Notification",
                "subject": "You are receiving this email because an administrator has reset your account password.",
                "password": "Your new password is: {password}",
                "sign_in": "We would recommend signing in to your account and changing this to something you can remember.",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "password_reset_request": {
                "greeting": "Hello!",
                "subject": "Reset Password Notification",
                "line_1": "You are receiving this email because we received a password reset request for your account.",
                "line_2": "Click the button below to reset your password:",
                "button": "Reset Password",
                "expire": "This password reset link will expire in {count} minutes",
                "notice": "If you did not request a password reset, no further action is required. Please note that this reset password link is only valid for one hour.",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "verify_password": {
                "email_subject": "User Verification Email",
                "subject": "Please click the button below to verify your email address.",
                "expire": "This email verification link will expire in {count} minutes",
                "button": "Verify Email Address",
                "notice": "If you did not create an account, no further action is required.",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "promote_user": {
                "subject": "Your have been promoted to Team Admin for the {team_name} team.",
                "greeting": "Hello",
                "promoted": "You have been promoted to Team Admin for the team {team_name} on the {toolkit} toolkit as part of {programme}.",
                "promoted_gi": "You have been promoted to Team Admin for the team {team_name} on the {toolkit} toolkit for {organisation} as part of {programme}.",
                "reason": "This happened when the current team admin left the platform and nominated you to take over this role. You can now manage your team on the {link} page.",
                "sign_off": "Thanks,<br>The SOS-UK Team.",
                "promoted_no_toolkit": "You have been promoted to Team Admin for the team {team_name} on the SOS Toolkit."
            },
            "gdpr_removal": {
                "subject": "A user has requested removal of their associated data from the system.",
                "greeting": "Hello",
                "body": "A user has deleted their account and requested that any associated data be removed from the system. There details are",
                "name": "name",
                "email": "email",
                "user_id": "User ID",
                "time_period": "The user should be contacted about their data removal within one calendar month",
                "sign_off": "Thanks,<br>The SOS-UK Platform."
            },
            "exports": {
                "report": {
                    "email_subject": "{type} Report ready to Download!",
                    "subject": "Your {type} Report is ready to download. The download link will be valid for 1 week.",
                    "button": "Download Report",
                    "email_subject_failed": "{type} Report failed",
                    "subject_failed": "Your {type} Report failed. Please log in and try again.",
                    "sign_off": "Thanks,<br>The SOS-UK Team."
                }
            },
            "reporting": {
                "password_reset": {
                    "email_subject": "A Reporting Supervisor has requested a password reset"
                }
            },
            "team_deletion": {
                "email_subject_team_deletion_reminder": "Reminder - your team {team} is scheduled to be deleted tomorrow",
                "email_subject_team_deleted": "Confirmation - your team {team} has now been deleted",
                "email_subject_team_scheduled_for_deletion": "Your team {team} has been scheduled for deletion"
            }
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address."
        },
        "reporting": {
            "header": {
                "title": "Reporting Portal"
            },
            "login": {
                "email": "Email address",
                "password": "Password",
                "forgot": "Forgot your password?",
                "log_in": "Log in",
                "log_out": "Log out"
            },
            "password_reset": {
                "password_reset_title": "Forgot your password? Enter your email address here and we'll send you a new one.",
                "request_password_reset": "Request password reset",
                "log_in": "Log in"
            },
            "dashboard": {
                "title": "Welcome to your reporting portal dashboard {supervisor_first_name} {supervisor_last_name}",
                "supervisor_email": "Your email address is: {supervisor_email}",
                "assigned_icb_region": "Your assigned ICB region is: {assigned_icb_region}",
                "assigned_private_org": "Your assigned private organisation is: {assigned_private_org}",
                "dashboard_intro_icb": "Organisations with relevant teams in your assigned ICB region are displayed below:",
                "dashboard_intro_org": " Teams in your assigned organisations are displayed below:",
                "dashboard_orgs": {
                    "current_toolkit_title": "The current toolkit for {organisation} is:",
                    "no_current_toolkit": "This organisation does not currently have an active current toolkit.",
                    "total_carbon_saved_title": "Total carbon estimated saved by this organisation for the current toolkit so far is:",
                    "teams_accordion_title": "Teams belonging to this organisation:",
                    "no_orgs": "There are currently no organisations or teams to display.",
                    "carbon_savings_inactive": "Carbon savings is not active for this toolkit."
                },
                "dashboard_teams": {
                    "total_actions": "Total actions completed so far:",
                    "no_completed_actions": "This team has either not yet completed any actions for this toolkit, or has not yet joined the current toolkit.",
                    "total_points": "Total points so far:",
                    "total_estimated_carbon": "Total estimated carbon saving so far:",
                    "users": "Number of users:",
                    "toolkit_status_title": "Toolkit Status:",
                    "toolkit_submitted_at": "Submitted at",
                    "toolkit_not_submitted": "Not submitted",
                    "no_teams": "There are currently no teams to display for this organisation."
                }
            }
        },
        "teams": {
            "create": {
                "details": "Team Details",
                "title": "Create a Team",
                "description": "Create a new team to collaborate with others on projects.",
                "create": "Create",
                "name": "{team_name} name",
                "create_team": "Create {team_name}"
            },
            "questions": {
                "title": "Additional information",
                "info": "Please answer the following additional questions about your {team_name}.",
                "option": "-- Please select an option --",
                "warning": "You have some unanswered questions. Please review the questions below and answer any blank questions marked as required.",
                "saved": "Answers saved successfully.",
                "error": "Something went wrong.",
                "required": "Please note that <span class=\"required-form-field\">*</span> indicates the field is required.",
                "save": "Save"
            },
            "delete": {
                "title": "Delete {team_name}",
                "description": "Permanently delete this {team_name}.",
                "warning": "Once a {team_name} is deleted, all of its resources and data will be permanently deleted. Before deleting this {team_name}, please download any data or information regarding this {team_name} that you wish to retain. \n        Once you request the team to be deleted, your team will be scheduled to be deleted in seven days.",
                "confirmation": "Are you sure you want to delete this {team_name}? Once a {team_name} is deleted, all of its resources and data will be permanently deleted.",
                "confirmation1": "Are you sure you want to permanently delete your {team_name} and all data? This will permanently delete all data associated with your {team_name} and cannot be undone. Any progress made towards your award will be lost.",
                "confirmation2": "If there are other members in your {team_name}, you should check with everyone that they are also happy for you to permanently delete the {team_name} as they may wish to continue to access the toolkit.",
                "confirmation3": "You may instead wish to delete your personal user account, which only deletes your own data, and not that of your {team_name}. You can do this on the user profile page.",
                "confirmation4": "If you are certain you wish to proceed with permanently deleting your {team_name} and all your progress, check below:",
                "cancel": "Cancel",
                "cancel_scheduled_deletion": "Cancel scheduled deletion",
                "scheduled_deletion_date_text": "This {team_name} is scheduled for deletion on <strong>{scheduled_deletion_date}</strong>.  To cancel this scheduled deletion, click on the button below:",
                "confirm": "Schedule {team_name} Deletion",
                "scheduled_for_deletion_title": "Scheduled for deletion",
                "confirmation_checkbox_label": "I am sure I want to delete this {team_name}",
                "no_delete_permission": "Only team admins are able to schedule a team for deletion. If your team is scheduled for deletion by one of the admins you will be notified by email and will be able to cancel the request here."
            },
            "join": {
                "programmes": {
                    "title": "Join a programme",
                    "teams": "for Teams",
                    "individuals": "for Individuals"
                },
                "teams": {
                    "title": "Join or create a {team_name}",
                    "info": "If your {team_name} doesn't already exist, you can create a brand new {team_name}",
                    "join": "Join {team_name}"
                }
            },
            "members": {
                "title": "{team_name} Members",
                "description": "All of the people that are part of this {team_name}.",
                "info": "A team must have at least one administrator. If you are the sole administrator and want to leave a team, please promote another member to administrator first.",
                "leave": "Leave",
                "owner": "Owner",
                "remove": "Remove",
                "add": {
                    "title": "Add New Member",
                    "description": "Add a new {team_name} member to your {team_name}, allowing them to collaborate with you.",
                    "info": "Please provide the email address of the person you would like to add to this {team_name}.",
                    "form": {
                        "email": "Email",
                        "role": "Role",
                        "submit": "Add",
                        "success": "Added."
                    }
                },
                "pending": {
                    "title": "Pending Team Invitations",
                    "description": "These people have been invited to your team and have been sent an invitation email. They may join the team by accepting the email invitation.",
                    "cancel": "Cancel"
                },
                "role": {
                    "title": "Manage Role",
                    "cancel": "Cancel",
                    "save": "Save"
                },
                "leave-modal": {
                    "title": "Leave Team",
                    "warning": "Are you sure you would like to leave this team?",
                    "cancel": "Cancel",
                    "confirm": "Leave"
                },
                "remove-modal": {
                    "title": "Remove Team Member",
                    "warning": "Are you sure you would like to remove this person from the team?",
                    "cancel": "Cancel",
                    "confirm": "Remove"
                }
            },
            "update": {
                "title": "{team_name} Name",
                "description": "The {team_name}'s name.",
                "owner": "{team_name} Owner",
                "name": "{team_name} Name",
                "success": "Saved.",
                "submit": "Save"
            },
            "carbon_savings": {
                "title": "Carbon Savings",
                "description": "Opt your {team_name} into or out of seeing carbon saving information.",
                "toggle": "Enable Carbon Savings information for my {team_name}",
                "success": "Saved.",
                "submit": "Save"
            },
            "settings": {
                "title": "{team_name} Settings"
            }
        },
        "toolkit": {
            "toolkit": "Toolkit",
            "intro_text": "All the available actions in your toolkit can be seen below. Not all actions will necessarily be relevant to you, so you can use the filters to find and sort the actions. You can also star actions for easy access on your dashboard, and assign actions to other {team_name} members (assigned actions will also appear on the dashboard).",
            "team": "Team",
            "submit": "Submit Toolkit",
            "no_toolkits": "There are currently no active Toolkits available to join. Please check back later.",
            "join": {
                "title": "Join a Toolkit",
                "button": "Join Toolkit"
            },
            "past": {
                "title": "Past Toolkits",
                "none": "Your {team_name} has not participated in any toolkits yet.",
                "retract": "Retract Submission",
                "status": "Status",
                "actions": "Actions",
                "score": "Score",
                "view": "View Toolkit",
                "completed_points": "Completed Points",
                "completed_actions": "Completed Actions",
                "out_of": "out of a possible",
                "awards": "Awards obtained",
                "not_applicable": "N/A",
                "awaiting_audit": "Awaiting Audit",
                "audit_in_progress": "Audit in progress",
                "action_required": "Action required",
                "audited": "Audited",
                "toolkit_submitted": "Submitted",
                "toolkit_completed": "Completed",
                "toolkit_incomplete": "Incomplete (Expired)",
                "toolkit_locked": "Locked",
                "toolkit_locked_warning": "This toolkit has been locked. You can no longer make changes to it.",
                "adminToolkit": "You are viewing this toolkit as an admin and cannot make changes to it.",
                "readOnly": "This is not a currently active toolkit and you cannot make changes to it. To view or join a current toolkit please <a href=\"{link}\" style=\"color{black}\">click here</a>."
            },
            "submission": {
                "title": "Submit Toolkit",
                "prompt": "Are you sure you want to submit this toolkit?",
                "warning": "You and your {team_name} members will no longer be able to edit any information after submission.",
                "name_change": "Would you like to change your {team_name} name before submission?",
                "cancel": "Cancel",
                "submit": "Submit",
                "submitted": "Toolkit Submitted",
                "congratulations": "Congratulations {team}!",
                "details_1": "You have submitted toolkit",
                "details_2": "for",
                "details_3": "as part of",
                "details_4": "Your answers will now be audited, and you will be contacted with more details soon. In the mean time, sit back, relax and give yourselves a pat on the back."
            },
            "nav": {
                "language_full": "Language"
            },
            "preview": {
                "preview_mode_short": "You are in Preview Mode",
                "preview_mode_long": "You are currently in Preview mode",
                "team": "Example team",
                "preview_dropdown": "Preview Toolkit in:"
            },
            "action": {
                "inactive": "This action is no longer active on the toolkit.",
                "criteria_tab": "Criteria",
                "information_tab": "Further information",
                "audited_tab": "How you will be audited",
                "comments_tab": "Comments & evidence",
                "comments": "Comments",
                "save_comment": "Save",
                "evidence": "Evidence",
                "add_evidence": "Add",
                "custom_fields": "Further Evidence",
                "total_points": "Total Points",
                "assigned_to": "Assigned to",
                "unassigned": "Unassigned",
                "assign": "Assign to a user",
                "evidence_upload": {
                    "title": "Upload Evidence to Action",
                    "warning": "Please do not upload any files which may contain sensitive or personal data!",
                    "warning_additional": "Uploads must be less than 8MB. If you need to reference a larger file, you can link to files in comments.",
                    "cancel": "Cancel",
                    "confirm": "Upload"
                },
                "carbon_savings": {
                    "title": "Carbon Savings",
                    "saving": "This action could save",
                    "co2": "{carbon_total} kg CO<sub>2</sub>"
                }
            },
            "filters": {
                "area": "Area",
                "award_level": "Award Level",
                "theme": "Theme",
                "status": "Status",
                "assigned_to": "Assigned To",
                "sdg": "SDG",
                "starred": "Starred",
                "count": "Seeing {length} results based on current applied filters."
            },
            "comment": {
                "deleted": "comment deleted by Admin",
                "added_by": "comment added by",
                "delete_confirm_title": "Please confirm!",
                "delete_warning": "Are you sure you want to delete this comment?",
                "delete_cancel": "Cancel",
                "delete_confirm": "Delete",
                "last_updated": "Last updated"
            },
            "custom_field": {
                "required": "This field is required. You cannot save it if it is empty.",
                "empty": "You cannot save an empty field.",
                "saved_date": "Current saved date",
                "save": "Save"
            },
            "evidence": {
                "uploaded_by": "uploaded by",
                "delete_confirm_title": "Please confirm!",
                "delete_warning": "Are you sure you want to delete this file?",
                "delete_cancel": "Cancel",
                "delete_confirm": "Delete"
            },
            "sort": {
                "sort_by_filter": "Sort By filter",
                "sort_direction": "Sort direction",
                "asc": "Ascending",
                "desc": "Descending",
                "sort": "Sort"
            },
            "export": {
                "title": "Export Actions as Excel Workbook",
                "print": "Print actions"
            }
        },
        "user": {
            "title": "Profile",
            "delete": {
                "title": "Delete Account",
                "description": "Permanently delete your account.",
                "info": "Once your account is deleted, all of its resources and data will be permanently deleted. Before deleting your account, please download any data or information that you wish to retain.",
                "delete_button": "Delete Account",
                "warning1": "Are you sure you want to delete your account?",
                "warning2": "Once your account is deleted, all of its resources and data will be permanently deleted.",
                "warning3": "Please enter your password to confirm you would like to permanently delete your account.",
                "password": "Password",
                "cancel": "Cancel",
                "confirm": "Delete Account",
                "permanent": {
                    "title": "Permanently delete your account.",
                    "description": "Permanently delete your account.",
                    "info": "You cannot delete your account if you are owner of a team which has no other Admin users.",
                    "admin_change_1": "Please change a team member to the Admin role on the",
                    "admin_change_2": "page. You can then nominate this user to become team owner when you delete your account.",
                    "admin_change_link": "Team Settings"
                },
                "soft": {
                    "info": "If you no longer wish to be part of this platform you can delete your account and any data you have contributed will be anonymised.",
                    "button": "Delete My Account"
                },
                "hard": {
                    "info": "You can request your account to be deleted along with any content you have created.",
                    "button": "Request removal of your account and associated data"
                },
                "modal": {
                    "title": "Delete Account",
                    "owner": "As you are team owner, you will need to assign team ownership to another admin user.",
                    "placeholder": "Assign Team Owner Role",
                    "warning": "Are you sure you want to delete your account? Please enter your password to confirm you would like to permanently delete your account.",
                    "info": "Removal of your associated data will be requested. You will be contacted regarding this within one calendar month.",
                    "team_removal": "As you are the sole member of your team, your team will also be removed.",
                    "password": "Password",
                    "cancel": "Cancel",
                    "confirm": "Delete Account"
                }
            },
            "browser_sessions": {
                "title": "Browser Sessions",
                "description": "Manage and log out your active sessions on other browsers and devices.",
                "info": "If necessary, you may log out of all of your other browser sessions across all of your devices. Some of your recent sessions are listed below; however, this list may not be exhaustive. If you feel your account has been compromised, you should also update your password.",
                "device": "This device",
                "active": "Last active",
                "logout_button": "Log Out Other Browser Sessions",
                "done": "Done.",
                "logout_title": "Log Out Other Browser Sessions",
                "logout_confirmation": "Please enter your password to confirm you would like to log out of your other browser sessions across all of your devices.",
                "logout_password": "Password",
                "logout_cancel": "Cancel",
                "logout_confirm": "Log Out Other Browser Sessions"
            },
            "2fa": {
                "title": "Two Factor Authentication",
                "description": "Add additional security to your account using two factor authentication.",
                "enabled": "You have enabled two factor authentication.",
                "finish_enabling": "Finish enabling two factor authentication.",
                "not_enabled": "You have not enabled two factor authentication.",
                "info": "When two factor authentication is enabled, you will be prompted for a secure, random token during authentication. You may retrieve this token from your phone's Google Authenticator application.",
                "enable_instructions": " To finish enabling two factor authentication, scan the following QR code using your phone's authenticator application or enter the setup key and provide the generated OTP code.",
                "finished_instructions": "Two factor authentication is now enabled. Scan the following QR code using your phone's authenticator application or enter the setup key.",
                "setup_key": "Setup Key:",
                "code": "Code",
                "recovery_code_info": "Store these recovery codes in a secure password manager. They can be used to recover access to your account if your two factor authentication device is lost.",
                "enable_button": "Enable",
                "confirm_button": "Confirm",
                "regenerate_recovery_codes_button": "Regenerate Recovery Codes",
                "show_recovery_codes_button": "Show Recovery Codes",
                "cancel": "Cancel",
                "disable": "Disable"
            },
            "password": {
                "title": "Update Password",
                "description": "Ensure your account is using a long, random password to stay secure.",
                "current_password": "Current Password",
                "new_password": "New Password",
                "confirm_password": "Confirm Password",
                "success": "Saved.",
                "submit": "Save"
            },
            "profile": {
                "title": "Profile Information",
                "description": "Update your account's profile information and email address.",
                "photo": "Photo",
                "photo_button": "Select A New Photo",
                "remove_photo_button": "Remove Photo",
                "first_name": "First Name",
                "last_name": "Last Name",
                "email": "Email",
                "email_unverified": "Your email address is unverified.",
                "email_unverified_button": "Click here to re-send the verification email.",
                "email_verification_sent": "A new verification link has been sent to your email address.",
                "preferred_language": "Preferred Language",
                "success": "Saved.",
                "submit": "Save"
            },
            "information": {
                "title": "Additional information",
                "description": "You can access and edit additional user profile information here.",
                "edit": "Edit additional information"
            },
            "questions": {
                "title": "Additional Profile Information",
                "info": "If you have just registered, once you have filled out the required questions below, you can join a team and toolkit by heading to the Toolkit in the menu.",
                "saved": "Answers saved successfully.",
                "description": "Please answer the following additional questions",
                "required": "Please note that <span class=\"required-form-field\">*</span> indicates the field is required.",
                "save": "Save",
                "not_requested": "No additional information has been requested at this time"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "accepted_if": "The {attribute} must be accepted when {other} is {value}.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} must only contain letters.",
            "alpha_dash": "The {attribute} must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} must only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "array": "The {attribute} must have between {min} and {max} items.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "numeric": "The {attribute} must be between {min} and {max}.",
                "string": "The {attribute} must be between {min} and {max} characters."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "declined": "The {attribute} must be declined.",
            "declined_if": "The {attribute} must be declined when {other} is {value}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "enum": "The selected {attribute} is invalid.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "array": "The {attribute} must have more than {value} items.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "numeric": "The {attribute} must be greater than {value}.",
                "string": "The {attribute} must be greater than {value} characters."
            },
            "gte": {
                "array": "The {attribute} must have {value} items or more.",
                "file": "The {attribute} must be greater than or equal to {value} kilobytes.",
                "numeric": "The {attribute} must be greater than or equal to {value}.",
                "string": "The {attribute} must be greater than or equal to {value} characters."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "array": "The {attribute} must have less than {value} items.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "numeric": "The {attribute} must be less than {value}.",
                "string": "The {attribute} must be less than {value} characters."
            },
            "lte": {
                "array": "The {attribute} must not have more than {value} items.",
                "file": "The {attribute} must be less than or equal to {value} kilobytes.",
                "numeric": "The {attribute} must be less than or equal to {value}.",
                "string": "The {attribute} must be less than or equal to {value} characters."
            },
            "mac_address": "The {attribute} must be a valid MAC address.",
            "max": {
                "array": "The {attribute} must not have more than {max} items.",
                "file": "The {attribute} must not be greater than {max} kilobytes.",
                "numeric": "The {attribute} must not be greater than {max}.",
                "string": "The {attribute} must not be greater than {max} characters."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "array": "The {attribute} must have at least {min} items.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "numeric": "The {attribute} must be at least {min}.",
                "string": "The {attribute} must be at least {min} characters."
            },
            "multiple_of": "The {attribute} must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": {
                "letters": "The {attribute} must contain at least one letter.",
                "mixed": "The {attribute} must contain at least one uppercase and one lowercase letter.",
                "numbers": "The {attribute} must contain at least one number.",
                "symbols": "The {attribute} must contain at least one symbol.",
                "uncompromised": "The given {attribute} has appeared in a data leak. Please choose a different {attribute}."
            },
            "present": "The {attribute} field must be present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "prohibits": "The {attribute} field prohibits {other} from being present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_array_keys": "The {attribute} field must contain entries for: {values}.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "array": "The {attribute} must contain {size} items.",
                "file": "The {attribute} must be {size} kilobytes.",
                "numeric": "The {attribute} must be {size}.",
                "string": "The {attribute} must be {size} characters."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}.",
            "doesnt_start_with": "The {attribute} may not start with one of the following: {values}.",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid timezone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} must be a valid URL.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    },
    "nl": {
        "application": {
            "welcome": {
                "content": "Bedankt om het online toolkitplatform te bezoeken. Je hebt de foutenpagina bereikt. Gebruik de volledige URL om toegang te bekomen tot de toolkit voor jouw programma, ajb. Indien je niet zeker bent welke jouw programma’s URL is, neem contact op met <a href=\"mailto:toolkit@sos-uk.org\">toolkit@sos-uk.org</a>.",
                "logo": "Logo"
            },
            "navigation": {
                "manage_account": "Accountbeheer",
                "profile": "Profiel",
                "api_tokens": "API-tokens",
                "log_out": "Uitloggen",
                "manage_team": "Beheer Team",
                "team_settings": "Team Instellingen",
                "switch_toolkits": "Omschakelen Toolkit",
                "clear_selection": "Clear Selection"
            },
            "general": {
                "cancel": "Annuleer",
                "password": "Wachtwoord",
                "error": "Oeps! Er ging iets mis.",
                "find_on_social_media": "Vind {naam} op sociale media:"
            },
            "email_validation": {
                "title": "Bevestig je e-mailadres om verder te gaan.",
                "info": "Je zou een e-mail moeten ontvangen hebben op het e-mailadres dat je gebruikte bij de registratie, voer de registratiecode uit de e-mail hieronder in.",
                "submit": "Indienen",
                "resend": "Indien je geen e-mail ontvang, kan je proberen een nieuwe bevestigingsmail te verzenden:",
                "resend_button": "Verificatie-e-mail opnieuw verzenden"
            },
            "email_verification": {
                "info": "Voordat we verder gaan, willen we je vragen om je e-mailadres te verifiëren door op de link te klikken die we je zojuist hebben toegestuurd. Als je de e-mail niet hebt ontvangen, sturen we je graag een nieuwe.",
                "link_sent": "Er is een nieuwe verificatielink verzonden naar het e-mailadres dat je hebt opgegeven in je profielinstellingen.",
                "resend_button": "Verificatie-e-mail opnieuw verzenden"
            },
            "auth": {
                "confirm_password": "Wachtwoord bevestigen",
                "confirm": "Bevestig",
                "forgot_password": "Wachtwoord vergeten? Geen probleem. Laat ons je e-mailadres weten en we sturen je een link waarmee je je wachtwoord opnieuw kunt instellen.",
                "email": "E-mail",
                "email_password": "E-mail wachtwoord resetten link",
                "reset_password": "Wachtwoord opnieuw instellen",
                "no_content": "Sorry, er is hier momenteel niets. Ga terug naar de <Link href=\"/\" style=\"color{black}\">homepage </Link> en probeer het opnieuw.",
                "reset_password_button": "Wachtwoord opnieuw instellen",
                "log_in": "Aanmelden",
                "2fa": {
                    "recovery": "Bevestig de toegang tot je account door de verificatiecode in te voeren die je van je authenticatietoepassing hebt gekregen.",
                    "confirm": "Bevestig de toegang tot je account door een van je noodherstelcodes in te voeren.",
                    "code": "Code",
                    "recovery_code": "Herstelcode",
                    "recovery_title": "Gebruik een herstelcode",
                    "authentication_title": "Gebruik een verificatiecode"
                }
            }
        },
        "dashboard": {
            "login": {
                "email": "E-mail",
                "password": "Wachtwoord",
                "logged_in": "Hou me aangemeld",
                "forgot": "Wachtwoord vergeten?",
                "log_in": "Aanmelden",
                "not_a_member": "Nog geen lid?",
                "register": "Registreer",
                "home": "Startpagina",
                "no_organisation": "Sorry, you need to specify an organisation to log in to this programme."
            },
            "register": {
                "first_name": "Voornaam",
                "last_name": "Achternaam",
                "email": "E-mail",
                "password": "Wachtwoord",
                "confirm_password": "Bevestig wachtwoord",
                "password_rules": "Je wachtwoord moet minstens 10 tekens lang zijn en minstens één speciaal teken en één cijfer bevatten.",
                "agree": "Ik ga akkoord met",
                "privacy_policy": "het privacybeleid",
                "registered": "Reeds geregistreerd?",
                "register": "Registreer",
                "no_organisation": "Sorry, you need to specify an organisation to register on this programme."
            },
            "title": "Dashboard",
            "greeting": "Hallo, {name}",
            "intro_text": "Ga naar je toolkit in het linkermenu.",
            "sidebar": {
                "dashboard": "Dashboard",
                "toolkit": "Toolkit"
            },
            "widgets": {
                "shared": {
                    "status": {
                        "done": "Klaar",
                        "in_progress": "Bezig",
                        "not_done": "Niet klaar",
                        "not_applicable": "N/A",
                        "none": "Geen Status"
                    }
                },
                "starred": {
                    "title": "Acties met ster",
                    "empty": "Je hebt momenteel geen acties met sterretjes om weer te geven."
                },
                "assigned": {
                    "title": "Toegewezen acties",
                    "empty": "Je hebt momenteel geen toegewezen acties om weer te geven."
                },
                "leaderboard": {
                    "title": "Scorebord",
                    "intro_text": "Top tien teams",
                    "points": "op aantal behaalde punten",
                    "actions": "op aantal voltooide acties",
                    "position": "Laat me de plaats van mijn team in het klassement zien",
                    "empty": "Je hebt momenteel geen inhoud om weer te geven."
                },
                "awards": {
                    "title": "Voortgang Prijzen",
                    "empty": "Er zijn op dit moment geen prijzen om te laten zien.",
                    "intro_text": "Bekijk de voortgang van je team voor het behalen van de prijzen van deze Toolkit.",
                    "points_score_status": "Your {team_name} has completed <strong>{totalCompletedActions}</strong> actions so far, totalling <strong>{totalPoints}</strong> points.",
                    "actions_score_status": "Your {team_name} has completed <strong>{totalCompletedActions}</strong> actions so far.",
                    "obtain": "Obtain",
                    "complete": "Complete",
                    "or_more": "or more",
                    "points": "points",
                    "between": "between",
                    "and": "and",
                    "award": "award",
                    "all": "all",
                    "from": "from",
                    "of": "of",
                    "tagged_actions": "actions tagged with this award",
                    "including_na": "(Including N/A)"
                },
                "new_toolkit": {
                    "new": "New",
                    "content": "There is a new toolkit available to join."
                },
                "previous_toolkits": {
                    "title": "Previous Toolkits"
                }
            }
        },
        "emails": {
            "toolkit_submitted": {
                "email_subject": "Toolkit Submitted",
                "hello": "Hello {team}",
                "subject_org": "Your {toolkit} toolkit for {organisation} as part of {programme} has been submitted!",
                "subject_prog": "Your {toolkit} toolkit as part of {programme} has been submitted!",
                "retractable": "If this was a mistake, or you would like to add more information to your actions, you can retract your submission in the toolkits section of your account.",
                "locked": "Your toolkit is now locked, so if this was a mistake, or you would like to add more information to your actions,",
                "email_admins": "please email your admin(s) at",
                "email": "please email",
                "auditor": "An auditor will be in touch with your team's admin soon!",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "toolkit_submitted_admin": {
                "email_subject": "Toolkit Submitted",
                "hello": "Hello!",
                "subject_org": "A {toolkit} toolkit for {organisation} as part of {programme} has been submitted for the team {team}!",
                "subject_prog": "A {toolkit} toolkit as part of {programme} has been submitted for the team {team}!",
                "retractable": "The team can still retract their submission in the toolkits section of their account.",
                "locked": "This team's toolkit is now locked, so they will need to contact you to make any alterations.",
                "auditor": "An auditor will be in touch with the team's admin soon!",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "toolkit_joined": {
                "email_subject": "Toolkit Joined",
                "hello": "Hello {team}",
                "fallback_content": "You have successfully joined a new toolkit!",
                "toolkit_details_header": "Your toolkit details are:",
                "toolkit_details_org": "{toolkit} toolkit for {organisation} as part of {programme}",
                "toolkit_details_prog": "{toolkit} toolkit for {organisation} as part of {programme}",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "toolkit_joined_admin": {
                "email_subject": "Toolkit Joined",
                "hello": "Hello!",
                "fallback_content": "A team has successfully joined a toolkit!",
                "team_details": "Team: {team}",
                "toolkit_details_org": "Toolkit: {toolkit} toolkit for {organisation} as part of {programme}",
                "toolkit_details_prog": "Toolkit: {toolkit} toolkit for {organisation} as part of {programme}",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "team_invite": {
                "email_subject": "Team Invitation",
                "subject": "You have been invited to join the {team} team!",
                "register": "If you do not have an account, you may create one by clicking the button below. After creating an account, you may click the invitation acceptance button in this email to accept the team invitation:",
                "create_account": "Create Account",
                "accept_1": "If you already have an account, you may accept this invitation by clicking the button below:",
                "accept_2": "You may accept this invitation by clicking the button below:",
                "accept_invitation": "Accept Invitation",
                "discard": "If you did not expect to receive an invitation to this team, you may discard this email."
            },
            "password_reset": {
                "email_subject": "Reset Password Notification",
                "subject": "You are receiving this email because an administrator has reset your account password.",
                "password": "Your new password is: {password}",
                "sign_in": "We would recommend signing in to your account and changing this to something you can remember.",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "password_reset_request": {
                "greeting": "Hello!",
                "subject": "Reset Password Notification",
                "line_1": "You are receiving this email because we received a password reset request for your account.",
                "line_2": "Click the button below to reset your password:",
                "button": "Reset Password",
                "expire": "This password reset link will expire in {count} minutes",
                "notice": "If you did not request a password reset, no further action is required. Please note that this reset password link is only valid for one hour.",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "verify_password": {
                "email_subject": "User Verification Email",
                "subject": "Please click the button below to verify your email address.",
                "expire": "This email verification link will expire in {count} minutes",
                "button": "Verify Email Address",
                "notice": "If you did not create an account, no further action is required.",
                "sign_off": "Thanks,<br>The SOS-UK Team."
            },
            "promote_user": {
                "subject": "Your have been promoted to Team Admin for the {team_name} team.",
                "greeting": "Hello",
                "promoted": "You have been promoted to Team Admin for the team {team_name} on the {toolkit} toolkit as part of {programme}.",
                "promoted_gi": "You have been promoted to Team Admin for the team {team_name} on the {toolkit} toolkit for {organisation} as part of {programme}.",
                "reason": "This happened when the current team admin left the platform and nominated you to take over this role. You can now manage your team on the {link} page.",
                "sign_off": "Thanks,<br>The SOS-UK Team.",
                "promoted_no_toolkit": "You have been promoted to Team Admin for the team {team_name} on the SOS Toolkit."
            },
            "gdpr_removal": {
                "subject": "A user has requested removal of their associated data from the system.",
                "greeting": "Hello",
                "body": "A user has deleted their account and requested that any associated data be removed from the system. There details are",
                "name": "name",
                "email": "email",
                "user_id": "User ID",
                "time_period": "The user should be contacted about their data removal within one calendar month",
                "sign_off": "Thanks,<br>The SOS-UK Platform."
            },
            "exports": {
                "report": {
                    "email_subject": "{type} Report ready to Download!",
                    "subject": "Your {type} Report is ready to download. The download link will be valid for 1 week.",
                    "button": "Download Report",
                    "email_subject_failed": "{type} Report failed",
                    "subject_failed": "Your {type} Report failed. Please log in and try again.",
                    "sign_off": "Thanks,<br>The SOS-UK Team."
                }
            },
            "reporting": {
                "password_reset": {
                    "email_subject": "A Reporting Supervisor has requested a password reset"
                }
            },
            "team_deletion": {
                "email_subject_team_deletion_reminder": "Reminder - your team {team} is scheduled to be deleted tomorrow",
                "email_subject_team_deleted": "Confirmation - your team {team} has now been deleted",
                "email_subject_team_scheduled_for_deletion": "Your team {team} has been scheduled for deletion"
            }
        },
        "teams": {
            "create": {
                "details": "Team Details",
                "title": "Creëer een Team",
                "description": "Een nieuw team maken om samen met anderen aan projecten te werken.",
                "create": "Creëer",
                "name": "Team naam",
                "create_team": "Creëer Team"
            },
            "questions": {
                "title": "Aanvullende informatie Team",
                "info": "Beantwoord de volgende aanvullende vragen over je team.",
                "option": "-- Selecteer een optie --",
                "warning": "Je hebt nog enkele onbeantwoorde vragen. Bekijk de onderstaande vragen en beantwoord de blanco vragen die als verplicht zijn gemarkeerd.",
                "saved": "Antwoorden succesvol opgeslagen.",
                "error": "Er ging iets mis.",
                "required": "Let op: <span class=\"verplicht-formulier-veld\">*</span> geeft aan dat het veld verplicht is.",
                "save": "Opslaan"
            },
            "delete": {
                "title": "Team verwijderen",
                "description": "Dit team permanent verwijderen.",
                "warning": "Zodra een team verwijderd is, worden alle bronnen en gegevens permanent verwijderd. Download voordat je dit team verwijdert alle gegevens of informatie over dit team die je wilt behouden.",
                "confirmation": "Weet je zeker dat je dit team wilt verwijderen? Als je een team verwijdert, worden alle bronnen en gegevens permanent verwijderd.",
                "confirmation1": "Are you sure you want to permanently delete your {team_name} and all data? This will permanently delete all data associated with your {team_name} and cannot be undone. Any progress made towards your award will be lost.",
                "confirmation2": "If there are other members in your {team_name}, you should check with everyone that they are also happy for you to permanently delete the {team_name} as they may wish to continue to access the toolkit.",
                "confirmation3": "You may instead wish to delete your personal user account, which only deletes your own data, and not that of your {team_name}. You can do this on the user profile page.",
                "confirmation4": "If you are certain you wish to proceed with permanently deleting your {team_name} and all your progress, check below:",
                "cancel": "Annuleren",
                "cancel_scheduled_deletion": "Cancel scheduled deletion",
                "scheduled_deletion_date_text": "This {team_name} is scheduled for deletion on <strong>{scheduled_deletion_date}</strong>.  To cancel this scheduled deletion, click on the button below:",
                "confirm": "Schedule {team_name} Deletion",
                "scheduled_for_deletion_title": "Scheduled for deletion",
                "confirmation_checkbox_label": "I am sure I want to delete this {team_name}",
                "no_delete_permission": "Only team admins are able to schedule a team for deletion. If your team is scheduled for deletion by one of the admins you will be notified by email and will be able to cancel the request here."
            },
            "join": {
                "programmes": {
                    "title": "Deelnemen aan een programma",
                    "teams": "voor Teams",
                    "individuals": "voor Individuen"
                },
                "teams": {
                    "title": "Word lid van een team of maak een team aan",
                    "info": "Als je team nog niet bestaat, kun je een nieuw team aanmaken",
                    "join": "Word lid van een team"
                }
            },
            "members": {
                "title": "Teamleden",
                "description": "Alle mensen die deel uitmaken van dit team.",
                "info": "A team must have at least one administrator. If you are the sole administrator and want to leave a team, please promote another member to administrator first.",
                "leave": "Verlaten",
                "owner": "Beheerder",
                "remove": "Verwijder",
                "add": {
                    "title": "Voeg Teamlid toe",
                    "description": "Voeg een nieuw teamlid toe aan je team, zodat zij met je kunnen samenwerken.",
                    "info": "Geef het e-mailadres op van de persoon die je wilt toevoegen aan dit team.",
                    "form": {
                        "email": "E-mail",
                        "role": "Rol",
                        "submit": "Toevoegen",
                        "success": "Toegevoegd."
                    }
                },
                "pending": {
                    "title": "Teamuitnodigingen in afwachting",
                    "description": "Deze mensen zijn uitgenodigd voor je team en hebben een uitnodigingse-mail ontvangen. Ze kunnen lid worden van het team door de e-mailuitnodiging te accepteren.",
                    "cencel": "Annuleer"
                },
                "role": {
                    "title": "Rol beheren",
                    "cancel": "Annuleer",
                    "save": "Opslaan"
                },
                "leave-modal": {
                    "title": "Team verlaten",
                    "warning": "Weet je zeker dat je dit team wilt verlaten?",
                    "cancel": "Annuleer",
                    "confirm": "Verlaten"
                },
                "remove-modal": {
                    "title": "Teamlid verwijderen",
                    "warning": "Weet je zeker dat je deze persoon uit het team wilt verwijderen?",
                    "cancel": "Annuleer",
                    "confirm": "Verwijderen"
                }
            },
            "update": {
                "title": "Teamnaam",
                "description": "De naam van het team en informatie over de beheerder.",
                "owner": "Teambeheerder",
                "name": "Teamnaam",
                "success": "Opgeslaan.",
                "submit": "Opslaan"
            },
            "settings": {
                "title": "Teaminstellingen"
            }
        },
        "toolkit": {
            "toolkit": "Toolkit",
            "intro_text": "Alle beschikbare acties in je toolkit kun je hieronder bekijken. Niet alle acties zijn noodzakelijkerwijs relevant voor jou, dus je kunt de filters gebruiken om de acties te vinden en te sorteren. Je kunt ook acties een ster geven zodat je ze gemakkelijk kunt terugvinden op je dashboard, en acties toewijzen aan andere teamleden (toegewezen acties verschijnen ook op het dashboard).",
            "team": "Team",
            "submit": "Toolkit indienen",
            "no_toolkits": "Er zijn momenteel geen actieve Toolkits beschikbaar om aan mee te doen. Kom later nog eens terug.",
            "join": {
                "title": "Word lid van een Toolkit",
                "button": "Word lid van Toolkit"
            },
            "past": {
                "title": "Toolkits uit het verleden",
                "none": "Jouw team heeft nog niet deelgenomen aan toolkits.",
                "retract": "Retract Submission",
                "status": "Status",
                "actions": "Acties",
                "score": "Score",
                "view": "View Toolkit",
                "completed_points": "Completed Points",
                "completed_actions": "Completed Actions",
                "out_of": "out of a possible",
                "awards": "Awards obtained",
                "not_applicable": "N/A",
                "awaiting_audit": "Awaiting Audit",
                "audit_in_progress": "Audit in progress",
                "action_required": "Action required",
                "audited": "Audited",
                "toolkit_submitted": "Submitted",
                "toolkit_completed": "Completed",
                "toolkit_incomplete": "Incomplete (Expired)",
                "toolkit_locked": "Locked",
                "toolkit_locked_warning": "This toolkit has been locked. You can no longer make changes to it.",
                "adminToolkit": "You are viewing this toolkit as an admin and cannot make changes to it.",
                "readOnly": "This is not a currently active toolkit and you cannot make changes to it. To view or join a current toolkit please <a href=\"{link}\" style=\"color{black}\">click here</a>."
            },
            "submission": {
                "title": "Toolkit indienen",
                "prompt": "Weet je zeker dat je deze toolkit wilt indienen?",
                "warning": "Jij en je teamleden kunnen na het indienen geen informatie meer bewerken.",
                "name_change": "Wil je je teamnaam wijzigen voordat je hem indient?",
                "cancel": "Annuleer",
                "submit": "Indienen",
                "submitted": "Toolkit ingediend",
                "congratulations": "Proficiat {team}!",
                "details_1": "Je hebt de toolkit ingediend",
                "details_2": "voor",
                "details_3": "als deel van",
                "details_4": "Jullie antwoorden zullen nu worden gecontroleerd en jullie zullen binnenkort worden gecontacteerd met meer details. En intussentijd: leun rustig achterover, ontspan en geef jezelf een schouderklopje."
            },
            "nav": {
                "language_full": "Taal"
            },
            "preview": {
                "preview_mode_short": "Je bevindt je in de Preview modus",
                "preview_mode_long": "Je bevindt je momenteel in de Preview modus",
                "team": "Voorbeeldteam",
                "preview_dropdown": "Preview Toolkit in:"
            },
            "action": {
                "inactive": "Deze actie is niet langer actief in de toolkit.",
                "criteria_tab": "Criteria",
                "information_tab": "Meer informatie",
                "audited_tab": "Hoe je geaudit wordt",
                "comments_tab": "Commentaar & bewijsmateriaal",
                "comments": "Commentaar",
                "save_comment": "Opslaan",
                "evidence": "Bewijsmateriaal",
                "add_evidence": "Toevoegen",
                "custom_fields": "Aangepaste velden",
                "total_points": "Totale Punten",
                "assigned_to": "Toegewezen aan",
                "unassigned": "Niet toegewezen",
                "assign": "Toewijzen aan een gebruiker",
                "evidence_upload": {
                    "title": "Bewijs uploaden naar actie",
                    "warning": "Upload geen bestanden die gevoelige of persoonlijke gegevens kunnen bevatten!",
                    "warning_additional": "Uploads must be less than 8MB. If you need to reference a larger file, you can link to files in comments.",
                    "cancel": "Annuleer",
                    "confirm": "Uploaden"
                },
                "carbon_savings": {
                    "title": "Carbon Savings",
                    "saving": "This action could save",
                    "co2": "{carbon_total} kg CO<sub>2</sub>"
                }
            },
            "filters": {
                "area": "Domein",
                "award_level": "Award niveau",
                "theme": "Thema",
                "status": "Status",
                "assigned_to": "Toegewezen aan",
                "sdg": "SDG",
                "starred": "Met ster",
                "count": "{length} resultaten op basis van de huidige toegepaste filters."
            },
            "comment": {
                "deleted": "commentaar verwijderd door Admin",
                "added_by": "commentaar toegevoegd door",
                "delete_confirm_title": "Bevestigen alsjeblieft!",
                "delete_warning": "Weet je zeker dat je deze opmerking wilt verwijderen?",
                "delete_cancel": "Annuleer",
                "delete_confirm": "Verwijder",
                "last_updated": "Last updated"
            },
            "custom_field": {
                "required": "Dit veld is verplicht. Je kan het niet opslaan als het leeg is.",
                "empty": "Je kan geen leeg veld opslaan.",
                "saved_date": "Huidige opgeslagen datum",
                "save": "Opslaan"
            },
            "evidence": {
                "uploaded_by": "geüpload door",
                "delete_confirm_title": "Bevestigen ajb!",
                "delete_warning": "Weet je zeker dat je dit bestand wilt verwijderen?",
                "delete_cancel": "Annuleer",
                "delete_confirm": "Verwijder"
            },
            "sort": {
                "sort_by_filter": "Sorteren op filter",
                "sort_direction": "Sorteerrichting",
                "asc": "Oplopend",
                "desc": "Aflopend",
                "sort": "Sorteer"
            },
            "export": {
                "title": "Acties exporteren als Excel-werkmap",
                "print": "Acties printen"
            }
        },
        "user": {
            "title": "Profiel",
            "delete": {
                "title": "Account verwijderen",
                "description": "Je account permanent verwijderen.",
                "info": "Zodra je account is verwijderd, worden alle bronnen en gegevens permanent verwijderd. Download voordat je je account verwijdert alle gegevens of informatie die je wilt behouden.",
                "delete_button": "Account verwijderen",
                "warning": "Weet je zeker dat je je account wilt verwijderen? Zodra je account is verwijderd, worden alle bronnen en gegevens permanent verwijderd. Voer je wachtwoord in om te bevestigen dat je je account definitief wilt verwijderen.",
                "password": "Wachtwoord",
                "cancel": "Annuleer",
                "confirm": "Verwijder Account",
                "permanent": {
                    "title": "Je account permanent verwijderen.",
                    "description": "Je account permanent verwijderen.",
                    "info": "Je kunt je account niet verwijderen als je beheerder bent van een team dat geen andere Admin-gebruikers heeft.",
                    "admin_change_1": "Wijzig een teamlid in de Admin rol op de",
                    "admin_change_2": "pagina. Je kunt deze gebruiker dan aanwijzen om teambeheerder te worden wanneer je je account verwijdert.",
                    "admin_change_link": "Teaminstellingen"
                },
                "soft": {
                    "info": "Als je niet langer deel wilt uitmaken van dit platform, kun je je account verwijderen en worden alle data die je hebt bijgedragen geanonimiseerd.",
                    "button": "Verwijder mijn Account"
                },
                "hard": {
                    "info": "Je kunt verzoeken om je account te verwijderen, samen met alle inhoud die je hebt gemaakt.",
                    "button": "De verwijdering van je account en bijbehorende gegevens aanvragen"
                },
                "modal": {
                    "title": "Verwijder Account",
                    "owner": "Omdat jij de beheerder van het team bent, moet je het beheerderschap van het team toewijzen aan een andere admin-gebruiker.",
                    "placeholder": "De rol van teambeheerder toewijzen",
                    "warning": "Weet je zeker dat je je account wilt verwijderen? Voer je wachtwoord in om te bevestigen dat je je account definitief wilt verwijderen.",
                    "info": "Er zal worden verzocht om je bijbehorende gegevens te verwijderen. Hierover wordt binnen een kalendermaand contact met je opgenomen.",
                    "team_removal": "Omdat je het enige lid van je team bent, wordt je team ook verwijderd.",
                    "password": "Wachtwoord",
                    "cancel": "Annuleer",
                    "confirm": "Verwijder Account"
                }
            },
            "browser_sessions": {
                "title": "Browser Sessies",
                "description": "Beheer en log uit op je actieve sessies op andere browsers en apparaten.",
                "info": "Indien nodig kan je uitloggen uit al je andere browsersessies op al je apparaten. Enkele van je recente sessies staan hieronder vermeld; deze lijst is echter mogelijk niet volledig. Als je denkt dat je account in gevaar is gebracht, moet je ook je wachtwoord bijwerken.",
                "device": "Dit toestel",
                "active": "Laatst actief",
                "logout_button": "Afmelden van andere browsersessies",
                "done": "Klaar.",
                "logout_title": "Afmelden van andere browsersessies",
                "logout_confirmation": "Voer je wachtwoord in om te bevestigen dat je je wilt afmelden van je andere browsersessies op al je apparaten.",
                "logout_password": "Wachtwoord",
                "logout_cancel": "Annuleer",
                "logout_confirm": "Andere browsersessies afmelden"
            },
            "2fa": {
                "title": "Twee Factor Authenticatie",
                "description": "Voeg extra beveiliging toe aan je account met tweefactorauthenticatie.",
                "enabled": "Je hebt twee factor authenticatie ingeschakeld.",
                "finish_enabling": "Twee Factor Authenticatie voltooien.",
                "not_enabled": "Je hebt twee factor authenticatie niet ingeschakeld.",
                "info": "Wanneer twee factor authenticatie is ingeschakeld, wordt je tijdens de verificatie gevraagd om een veilig, willekeurig token. Je kan dit token ophalen uit de Google Authenticator-applicatie van je telefoon.",
                "enable_instructions": "Om twee factor authenticatie in te schakelen, scan je de volgende QR-code met de authenticatietoepassing van je telefoon of voer je de installatiesleutel in en geef je de gegenereerde OTP-code op.",
                "finished_instructions": "Twee factor authenticatie is nu ingeschakeld. Scan de volgende QR-code met de authenticatietoepassing van je telefoon of voer de installatiesleutel in.",
                "setup_key": "Installatiesleutel:",
                "code": "Code",
                "recovery_code_info": "Bewaar deze herstelcodes in een veilige wachtwoordmanager. Ze kunnen worden gebruikt om toegang tot je account te krijgen als je tweefactorauthenticatieapparaat verloren gaat.",
                "enable_button": "Inschakelen",
                "confirm_button": "Bevestigen",
                "regenerate_recovery_codes_button": "Herstelcodes regenereren",
                "show_recovery_codes_button": "Herstelcodes tonen",
                "cancel": "Annuleren",
                "disable": "Uitschakelen"
            },
            "password": {
                "title": "Wachtwoord bijwerken",
                "description": "Zorg ervoor dat je account een lang, willekeurig wachtwoord gebruikt om veilig te blijven.",
                "current_password": "Huidig wachtwoord",
                "new_password": "Nieuw wachtwoord",
                "confirm_password": "Bevestig wachtwoord",
                "success": "Opslaan.",
                "submit": "Opslaan"
            },
            "profile": {
                "title": "Profiel Informatie",
                "description": "Werk de profielgegevens en het e-mailadres van je account bij.",
                "photo": "Foto",
                "photo_button": "Selecteer een nieuwe foto",
                "remove_photo_button": "Verwijder foto",
                "first_name": "Voornaam",
                "last_name": "Achternaam",
                "email": "E-mail",
                "email_unverified": "Je e-mailadres is niet geverifieerd.",
                "email_unverified_button": "Klik hier om de verificatiemail opnieuw te versturen.",
                "email_verification_sent": "Er is een nieuwe verificatielink naar je e-mailadres gestuurd.",
                "preferred_language": "Voorkeurstaal",
                "success": "Opgeslaan.",
                "submit": "Opslaan"
            },
            "information": {
                "title": "Aanvullende informatie",
                "description": "Hier kan je aanvullende profielgegevens van gebruikers openen en bewerken.",
                "edit": "Extra informatie bewerken"
            },
            "questions": {
                "title": "Aanvullende profielinformatie",
                "info": "Als je je net hebt geregistreerd, kun je, nadat je de verplichte vragen hieronder hebt ingevuld, lid worden van een team en een toolkit door naar de Toolkit in het menu te gaan.",
                "saved": "Antwoorden succesvol opgeslagen.",
                "description": "Beantwoord de volgende aanvullende vragen",
                "required": "Let op: <span class=\"verplicht-formulier-veld\">*</span> geeft aan dat het veld verplicht is.",
                "save": "Opslaan",
                "not_requested": "Er is op dit moment geen aanvullende informatie gevraagd"
            }
        }
    }
}
